// src/services/paymentService.js
import api from './api';

const paymentService = {
  getPublicKey: async () => {
    const res = await api.get('/v1/payments/public-key');
    return res.data;
  },

  initialize: async (plan = 'pro', interval = 'monthly') => {
    const res = await api.post('/v1/payments/initialize', { plan, interval });
    return res.data;
  },

  createSubscription: async (plan = 'pro', interval = 'monthly') => {
    const res = await api.post('/v1/payments/subscribe', { plan, interval });
    return res.data;
  },

  verify: async (reference) => {
    const res = await api.post('/v1/payments/verify', { reference });
    return res.data;
  },

  cancel: async (subscriptionCode) => {
    const res = await api.post('/v1/payments/cancel', { subscriptionCode });
    return res.data;
  },

  listTransactions: async (page = 1, perPage = 20) => {
    const res = await api.get('/v1/payments/transactions', { params: { page, perPage } });
    return res.data;
  },

  getPlans: async () => {
    const res = await api.get('/v1/payments/plans');
    return res.data;
  }
};

export default paymentService;